import { AsyncAction } from 'src/utils/reduxUtils'
import { ApiService, callClientSecureApi } from './api/callApi'
import { call, put, takeLatest } from 'redux-saga/effects'
import { Endpoints } from 'src/constants/endpoints'
import { getApiErrorMessage } from 'src/utils/errorHandlers'
import { FetchDriver, UploadBankInformation } from 'src/constants/actionTypes'
import {
  PaymentMethodRecipientNamePreference,
  PaymentMethodTypeEnum,
  RecipientTypeEnum,
} from 'src/interfaces/paymentMethod'

interface BankInformationRequest {
  routingNumber: string
  accountNumber: string
  accountType: string
  stepId: string
  hasBusinessEntity: boolean
  recipientNamePreference: PaymentMethodRecipientNamePreference
}

function* onUploadBankInformation(action: AsyncAction<BankInformationRequest>) {
  const {
    routingNumber,
    accountNumber,
    accountType,
    stepId,
    hasBusinessEntity,
    recipientNamePreference,
  } = action.payload

  try {
    yield call(callClientSecureApi, Endpoints.UploadPaymentMethod, {
      method: 'POST',
      body: {
        stepId,
        paymentMethodType: PaymentMethodTypeEnum.BankAccount,
        recipientNamePreference,
        bankAccountDetails: {
          recipientType: hasBusinessEntity
            ? RecipientTypeEnum.Business
            : RecipientTypeEnum.Individual,
          routingNumber,
          accountNumber,
          accountType,
        },
      },
      apiService: ApiService.Paraworks,
    })

    yield put(UploadBankInformation.success())

    yield put(FetchDriver.request())

    if (action.next) {
      action.next(null)
    }
  } catch (err: any) {
    const errorMessage = getApiErrorMessage(err, 'Failed to upload bank information')

    yield put(UploadBankInformation.failed(err))

    if (action.next) {
      action.next(errorMessage)
    }
  }
}

export function* bankInformationSaga() {
  yield takeLatest(UploadBankInformation.type.REQUEST, onUploadBankInformation)
}
